//#region src/schema/localization/locales/es.ts
var e = {
	schema: {
		variants: "Variantes",
		discriminatorValue: "Valor del discriminador",
		noAllowedValues: "Ningún valor satisface esta restricción enum.",
		example: "Ejemplo",
		examples: "Ejemplos",
		default: "Predeterminado",
		schema: "Esquema",
		emptyObject: "Objeto vacío",
		showAdditionalProperties: "Mostrar propiedades adicionales",
		showOneMoreProperty: "Mostrar 1 propiedad más",
		showMoreProperties: "Mostrar {count} propiedades más",
		forName: "para {name}",
		showSchemaDetails: "Mostrar detalles del esquema",
		oneOf: "Uno de",
		anyOf: "Cualquiera de",
		allOf: "Todos de",
		not: "No",
		unknownType: "tipo desconocido",
		propertyCount: "Propiedades: {count}",
		headerCount: "Encabezados: {count}",
		recursiveReference: "Referencia recursiva a {name}",
		recursive: "recursivo",
		additionalProperties: "propiedades adicionales",
		const: "constante",
		deprecated: "obsoleto",
		discriminator: "Discriminador",
		enum: "enum",
		format: "Formato",
		greaterThan: "mayor que",
		keys: "claves",
		lessThan: "menor que",
		max: "máx.",
		min: "mín.",
		maxLength: "longitud máx.",
		minLength: "longitud mín.",
		multipleOf: "múltiplo de",
		nullable: "admite null",
		propertyNames: "nombres de propiedades",
		pattern: "Patrón",
		copyPattern: "Copiar patrón",
		readOnly: "solo lectura",
		required: "obligatorio",
		hideValues: "Ocultar valores",
		showAllValues: "Mostrar todos los valores",
		type: "Tipo",
		unique: "único",
		values: "valores",
		writeOnly: "solo escritura",
		typeInteger: "Números enteros.",
		formatInt32: "Enteros de 32 bits con signo (tipo entero de uso común).",
		formatInt64: "Enteros de 64 bits con signo (tipo long).",
		formatDate: "notación full-date definida en RFC 3339, sección 5.6, por ejemplo, 2017-07-21",
		formatDateTime: "notación date-time definida en RFC 3339, sección 5.6, por ejemplo, 2017-07-21T17:32:28Z",
		formatPassword: "indica a las interfaces que oculten la entrada",
		formatBase64: "caracteres codificados en base64, por ejemplo, U3dhZ2dlciByb2Nrcw==",
		formatBinary: "datos binarios, usados para describir archivos"
	},
	common: {
		copyDefault: "Copiar valor por defecto",
		copyExample: "Copiar valor de ejemplo"
	},
	actions: { copyLinkTo: "Copiar enlace a {name}" }
};
//#endregion
export { e as es };

//# sourceMappingURL=es.js.map